// 루트
export const ROUTE_ROOT = '/';

// 회원가입
export const ROUTE_SIGN_UP = '/sign-up';

// 로그인
export const ROUTE_SIGN_IN = '/sign-in';

// 공지
export const ROUTE_NOTICE = '/notice';

// pjt
export const ROUTE_PJT = '/pjt';

// company
export const ROUTE_COMPANY = '/company';

// user
export const ROUTE_USER = '/user';
export const ROUTE_USER_APPROVAL = `${ROUTE_USER}/user-approval`;
export const ROUTE_USER_ADMINISTRATOR_MANAGEMENT = `${ROUTE_USER}/administrator-management`;
export const ROUTE_USER_WORKER_MANAGEMENT = `${ROUTE_USER}/worker-management`;

//passport
export const ROUTE_PASSPORT = '/passport';
export const ROUTE_PASSPORT_SITE_ENTRY_MANAGEMENT = `${ROUTE_PASSPORT}/site-entry-management`;
export const ROUTE_PASSPORT_SAFETY_TRAINING = `${ROUTE_PASSPORT}/safety-training`;
export const ROUTE_PASSPORT_TRAINING_SETTING = `${ROUTE_PASSPORT}/training-setting`;
export const ROUTE_PASSPORT_SITE_ENTRY_HISTORY = `${ROUTE_PASSPORT}/site-entry-history`;

// Environment (Weather & Air Quality Monitoring)
export const ROUTE_ENVIRONMENT = '/environment';
export const ROUTE_ENVIRONMENT_CURRENT = `${ROUTE_ENVIRONMENT}/current`;
export const ROUTE_ENVIRONMENT_HISTORTY = `${ROUTE_ENVIRONMENT}/history`;

// 대시보드
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_CHART_DASHBOARD = `${ROUTE_DASHBOARD}/chart`;
export const ROUTE_MAP_DASHBOARD = `${ROUTE_DASHBOARD}/map`;

// system
export const ROUTE_SYSTEM = '/system';

// TBM - tool box meeting
export const ROUTE_TBM = '/tbm';
export const ROUTE_TBM_STATUS = `${ROUTE_TBM}/status`;
export const ROUTE_TBM_ATTENDANCE = `${ROUTE_TBM}/attendance`;
export const ROUTE_TBM_MONITORING = `${ROUTE_TBM}/monitoring`;

// Heavy Equipment
export const ROUTE_HEAVY_EQUIPMENT = '/heavy-equipment';
export const ROUTE_HEAVY_EQUIPMENT_MANAGEMENT = `${ROUTE_HEAVY_EQUIPMENT}/management`;
export const ROUTE_HEAVY_EQUIPMENT_MY = `${ROUTE_HEAVY_EQUIPMENT}/my`;
export const ROUTE_HEAVY_EQUIPMENT_STATUS = `${ROUTE_HEAVY_EQUIPMENT}/status`;
export const ROUTE_HEAVY_EQUIPMENT_SETTING = `${ROUTE_HEAVY_EQUIPMENT}/setting`;
export const ROUTE_HEAVY_EQUIPMENT_HISTORY = `${ROUTE_HEAVY_EQUIPMENT}/history`;

// Smart Device (PKG2 - GS 전용)
const ROUTE_SMART_DEVICE = '/smart-device';
export const ROUTE_SMART_DEVICE_MANAGEMENT = `${ROUTE_SMART_DEVICE}/management`;
export const ROUTE_SMART_DEVICE_DISTRIBUTION = `${ROUTE_SMART_DEVICE}/distribution`;
export const ROUTE_SMART_DEVICE_ALERT_HISTORY = `${ROUTE_SMART_DEVICE}/alert-history`;
export const ROUTE_SMART_DEVICE_ENVIRONMENT_SENSOR_MANAGEMENT = `${ROUTE_SMART_DEVICE}/environment-sensor-management`;
